// import Link from "next/link";
import CoreValues from "../components/CoreValues";
import DistributionNetwork from "../components/DistributionNetwork";
import InnerHero from "../components/InnerHero";
import ProductHighlights from "../components/ProductHighlights";
import CTASection from "../components/CTASection";
import MapSection from "../components/MapSection";
import StatsSection from "../components/StatsSection";
import CategoriesSection from "../components/CategoriesSection";

function About() {
    return (
        <>
            {/* Hero Section */}
            <InnerHero
                title="About Us"
                subtitle="Rooted in farming, driven by innovation and committed to sustainable agriculture."
                breadcrumb="Home"
                bgImage="/images/img/10.jpg"
            />
            {/* OUR STORY Section  */}
            <section className="our-story-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="our-story-content">
                                <h6 className="section-subtitle">OUR STORY</h6>
                                <h2>
                                    Rooted in <span>Farming</span>, Growing with <span>Trust</span>
                                </h2>
                                <p>
                                    Goodweel Crop Care was founded with a simple yet powerful belief —
                                    <strong> farming is not just a profession, it is a way of life</strong>.
                                    Our journey began over 10+ years ago with a deep connection to
                                    Indian soil and a clear understanding of the real challenges
                                    faced by farmers in the field.
                                </p>
                                <p>
                                    From the very beginning, we focused on listening to farmers,
                                    learning from real on-field experiences, and developing solutions
                                    that actually work under Indian farming conditions. What started
                                    as a commitment to quality has grown into a trusted agricultural
                                    brand serving farmers across multiple regions of India.
                                </p>
                                <p>
                                    Today, Goodweel Crop Care stands as a reliable partner to farmers,
                                    offering scientifically developed, eco-friendly, and performance-driven
                                    crop protection and nutrition solutions. Our growth is deeply
                                    connected to farmer success — when farmers grow, we grow with them.
                                </p>
                            </div>
                        </div>
                        {/* RIGHT IMAGE + HIGHLIGHT */}
                        <div className="col-lg-6">
                            <div className="our-story-image">
                                <img
                                    src="/images/img/ourstory.png"
                                    alt="Goodweel Crop Care Journey"
                                    className="img-fluid"
                                />
                                <div className="story-badge">
                                    <h4>10+ Years</h4>
                                    <span>of Farmer Trust</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="vision-mission-section">
                <div className="container">

                    {/* HEADING */}
                    <div className="text-center mb-5">
                        <h6 className="section-subtitle">OUR DIRECTION</h6>
                        <h2 className="section-title">
                            Vision & <span>Mission</span>
                        </h2>
                        <p className="section-desc">
                            Our vision defines where we want to go, and our mission guides
                            how we achieve it — with farmers, sustainability, and innovation
                            at the core of everything we do.
                        </p>
                    </div>

                    <div className="row">

                        {/* VISION */}
                        <div className="col-lg-6 mb-4">
                            <div className="vm-card vision">
                                <div className="vm-icon">🌱</div>
                                <h3>Our Vision</h3>
                                <p>
                                    To create a future where farming is
                                    <strong> smart, sustainable, and profitable</strong>,
                                    supported by modern agricultural technology and
                                    time-tested farming knowledge.
                                </p>
                                <p>
                                    We envision an agricultural ecosystem where farmers grow
                                    with confidence, productivity increases responsibly,
                                    and natural resources like soil and water remain protected
                                    for future generations.
                                </p>
                                <p>
                                    Our vision is not limited to higher yields alone, but to
                                    building a balanced relationship between
                                    <strong> farmers, crops, and nature</strong>.
                                </p>
                            </div>
                        </div>

                        {/* MISSION */}
                        <div className="col-lg-6 mb-4">
                            <div className="vm-card mission">
                                <div className="vm-icon">🚜</div>
                                <h3>Our Mission</h3>

                                <ul className="mission-list">
                                    <li>
                                        To provide <strong>safe, effective, and easy-to-use</strong>
                                        crop protection and nutrition solutions that deliver
                                        consistent results in real field conditions.
                                    </li>
                                    <li>
                                        To promote <strong>eco-friendly and sustainable</strong>
                                        agricultural practices that protect soil health,
                                        water resources, and the environment.
                                    </li>
                                    <li>
                                        To continuously innovate through
                                        <strong> research, quality improvement, and field trials</strong>
                                        to meet evolving farming challenges.
                                    </li>
                                    <li>
                                        To build long-term trust with farmers and partners
                                        through <strong>honesty, performance, and support</strong>.
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <CoreValues />
            <DistributionNetwork />
            <CategoriesSection />
            <ProductHighlights />
            <section className="compliance-section">
                <div className="container">

                    {/* HEADING */}
                    <div className="text-center mb-4">
                        <h6 className="section-subtitle">CERTIFICATIONS & COMPLIANCE</h6>
                        <h2 className="section-title">
                            Committed to <span>Standards, Safety & Law</span>
                        </h2>
                        <p className="section-desc">
                            At Goodweel Crop Care, compliance is not an option — it is a
                            responsibility we follow at every stage of our operations.
                        </p>
                    </div>

                    <div className="row mt-3">

                        {/* LEFT – EXPLANATION */}
                        <div className="col-lg-6">
                            <div className="compliance-text">
                                <p>
                                    We operate with a strong focus on quality management,
                                    regulatory adherence, and ethical manufacturing practices.
                                    Our systems are designed to meet nationally and
                                    internationally recognized standards.
                                </p>

                                <p>
                                    From procurement of raw materials to manufacturing,
                                    testing, packaging, and distribution — every process
                                    follows documented procedures, legal guidelines,
                                    and quality benchmarks.
                                </p>

                                <p>
                                    This disciplined approach ensures that our products
                                    are safe, reliable, and compliant with agricultural
                                    regulations, giving farmers and partners complete confidence.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT – ISO & LEGAL POINTS */}
                        <div className="col-lg-6">
                            <div className="compliance-points-box">
                                <h4>Quality & Legal Assurance</h4>

                                <ul>
                                    <li>
                                        ISO 9001 : 2015 certified Quality Management System
                                    </li>
                                    <li>
                                        Compliance with applicable agricultural and industrial laws
                                    </li>
                                    <li>
                                        Batch-wise quality checks and internal audits
                                    </li>
                                    <li>
                                        Proper documentation and traceability at every stage
                                    </li>
                                    <li>
                                        Ethical, transparent, and legally approved operations
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="compliance-footer">
                        <p>
                            These certifications and compliance practices reflect our long-term
                            commitment to quality, safety, and responsible business conduct.
                        </p>
                    </div>

                </div>
            </section>
            <StatsSection />
            <MapSection />
            <CTASection />



        </>
    );
}

export default About;